export default {"src":"/_next/static/media/lock-icon.7768a07d.svg","height":512,"width":513};